import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'

import { ROLES } from '@/entities/auth'
import { OrdersPage } from '@/pages/orders-page'
import type {
    GetOrdersQueryParams,
    GetOrdersQueryParamsPaymentMethodEnum,
    GetOrdersQueryParamsStatusEnum,
} from '@/shared/api'
import { LIMIT_OPTIONS, type LimitType } from '@/shared/model'

type OrdersSearch = Omit<GetOrdersQueryParams, 'limit' | 'offset' | 'from_date' | 'to_date'> & {
    limit: LimitType
    page: number
    from_date: string
    to_date: string
}

export const Route = createFileRoute('/_dashboard/orders')({
    component: OrdersPage,
    onEnter: () => {
        document.title = 'Taxoparkee - Заказы'
    },
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager])) {
            throw redirect({
                to: '/recruitment',
                search: { page: 1 },
            })
        }
    },
    validateSearch: (search: Record<string, unknown>): OrdersSearch => {
        return {
            page: (search.page as number) ?? 1,
            limit: (search.limit as number) ?? LIMIT_OPTIONS[0],
            from_address: search.from_address === '' ? undefined : (search.from_address as string),
            to_address: search.to_address === '' ? undefined : (search.to_address as string),
            from_date: (search.from_date as string) ?? dayjs().format('DD-MM-YYYY'),
            to_date: (search.to_date as string) ?? dayjs().format('DD-MM-YYYY'),
            payment_method:
                Array.isArray(search.payment_method) && search.payment_method.length === 0
                    ? undefined
                    : (search.payment_method as GetOrdersQueryParamsPaymentMethodEnum[]),
            status:
                Array.isArray(search.status) && search.status.length === 0
                    ? undefined
                    : (search.status as GetOrdersQueryParamsStatusEnum[]),
            phone: search.phone === '' ? undefined : (search.phone as string),
        }
    },
})
